<template>
  <section class="content">
      <div class="container-fluid">
      <div id="calendar"></div>

      <!-- Modal Custom (Tanpa Bootstrap) -->
      <div v-if="showModal" class="modal-overlay">
        <div class="modal-box">
          <h5>Edit Event</h5>
          <input v-model="editEventTitle" class="form-input" placeholder="Judul Event Baru" />
          <div class="modal-actions">
            <button @click="deleteEvent" class="btn btn-danger">Hapus</button>
            <button @click="updateEvent" class="btn btn-primary">Simpan</button>
            <button @click="showModal = false" class="btn btn-secondary">Batal</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/helper/api'

/* eslint-disable */

export default {
  name: "CalendarView",
  data() {
    return {
      selectedEvent: null,
      editEventTitle: '',
      showModal: false,
    };
  },
  mounted() {
    const calendarEl = document.getElementById("calendar");
    const calendar = new window.FullCalendar.Calendar(calendarEl, {
      initialView: "dayGridMonth",
      selectable: true, // ini penting untuk multiple select
      eventClick: (info) => this.handleEventClick(info), // Handle event click for update/delete
      select: function (info) {
        const title = prompt(
          `Masukkan judul event dari ${info.startStr} ke ${info.endStr}:`
        );
        if (title) {
          // Menambahkan event ke kalender lokal
          calendar.addEvent({
            title: title,
            start: info.startStr,
            end: info.endStr,
            allDay: true
          });

          // Data yang akan dikirim ke backend
          const eventData = {
            title: title,
            start: info.startStr,
            end: info.endStr
          };

          // Mengatur header Authorization dengan token
          api.defaults.headers.common["Authorization"] =
            "Bearer " + localStorage.getItem("_token");

          // Mengirim data event ke backend
          api
            .post("/insertEvent", eventData)
            .then(result => {
              if (result.data.code === 200) {
                this.$toastr.s("Tambah data berhasil");
              } else {
                let msg = "Tambah data gagal";
                if (result.data.message !== "") msg = result.data.message;
                this.$toastr.e(msg);
              }
              this.isLoading = false;
            })
            .catch(e => {
              let msg = "Terjadi kesalahan pada server, mohon ulangi";
              // if (e.response.data.message) msg = e.response.data.message;
              this.$toastr.e(msg);
              this.isLoading = false;
            });
        }
      }
    });
    calendar.render();

    api.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("_token");
    api.get("/getallKalender")
      .then(response => {
        const serverEvents = response.data.content; // sesuaikan dengan struktur datamu
        serverEvents.forEach(evt => {
          calendar.addEvent({
            id: evt.id,
            title: evt.title,
            start: evt.start,
            end: evt.end,
            allDay: true
          });
        });
        calendar.render();
      })
      .catch(e => {
        this.$toastr.e("Gagal memuat data event dari server");
        calendar.render();
      });
  },

methods: {
    handleEventClick(info) {
      this.selectedEvent = info.event;
      this.editEventTitle = info.event.title;
      this.showModal = true;
    },
    updateEvent() {
      if (!this.selectedEvent || !this.editEventTitle) return;

      this.selectedEvent.setProp('title', this.editEventTitle);

      const updatedEvent = {
        id: this.selectedEvent.id,
        title: this.editEventTitle,
        start: this.selectedEvent.startStr,
        end: this.selectedEvent.endStr
      };

      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      api.post(`/updateEvent/${updatedEvent.id}`, updatedEvent)
        .then(result => {
          if (result.status === 200) {
            this.$toastr.s('Update data berhasil');
          } else {
            this.$toastr.e('Update data gagal');
          }
        })
        .catch(() => {
          this.$toastr.e('Terjadi kesalahan saat update');
        });

      this.showModal = false;
    },
    deleteEvent() {
      if (!this.selectedEvent) return;

      const id = this.selectedEvent.id;
      this.selectedEvent.remove();

      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      api.delete(`/deleteEvent/${id}`)
        .then(result => {
          if (result.status === 200) {
            this.$toastr.s('Event berhasil dihapus');
          } else {
            this.$toastr.e('Gagal menghapus event');
          }
        })
        .catch(() => {
          this.$toastr.e('Terjadi kesalahan saat hapus');
        });

      this.showModal = false;
    }
  }
};
</script>

<style>
#calendar {
  max-width: 900px;
  margin: 40px auto;
  background-color: white;
  padding: 20px;
  border-radius: 20px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-box {
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.btn {
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
  border: none;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
}

.form-input {
  width: 100%;
  padding: 8px;
  margin-top: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/view/Kalender/Calender.vue